import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/index';


@Injectable({ providedIn: 'root' })
export class JyMenuService extends BaseService {

  private url = 'api/menu';  // URL to web api

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }


  all(): Observable<any> {
    const url = `${this.getUrl()}/all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`all menu`)),
      catchError(this.handleError<any>(`get all menu`)),
    );
  }

  top(): Observable<any> {
    const url = `${this.getUrl()}/top`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`top menu`)),
      catchError(this.handleError<any>(`get top menu`)),
    );
  }

  getWithChildren(id: string): Observable<any> {
    const url = `${this.getUrl()}/${id}/with-children`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`get menu With Children`)),
      catchError(this.handleError<any>(`get menu With Children`)),
    );
  }

  current(): Observable<any> {
    const url = `${this.getUrl()}/current`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`current menu`)),
      catchError(this.handleError<any>(`get current menu`)),
    );
  }


  permission(object: any): Observable<any> {
    const url = `${this.getUrl()}/permission`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`menu permission =${object}`)),
      catchError(this.handleError<any>('menu permission ')),
    );
  }

//  获取当前时间
  getCurrentTime(): Observable<any[]> {
    const url = `api/date/current-time`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getCurrentTime`)),
      catchError(this.handleError<any>(`getCurrentTime`))
    );
  }
}

